import React from "react";
import githubLogo from "../IMG/GitHub-Mark.png";
import leetcodeLogo from "../IMG/LeetCode_logo_black.png";
import gfgLogo from "../IMG/GeeksforGeeks.svg";
import oracleBadge from "../IMG/oracle badge.jpg"

const FeaturedLinks = () => {
  const links = [
    {
      id: 1,
      title: "GitHub Profile - Akshat Srivastava",
      subtitle: "GitHub",
      image: githubLogo,
      link: "https://github.com/Sri-Akshat5",
    },
    {
      id: 2,
      title: "LeetCode Profile - Akshat Srivastava",
      subtitle: "LeetCode",
      image: leetcodeLogo,
      link: "https://leetcode.com/sri_akshat5/",
    },
    {
      id: 3,
      title: "GeeksforGeeks Profile - Akshat Srivastava",
      subtitle: "auth.geeksforgeeks.org",
      image: gfgLogo,
      link: "https://auth.geeksforgeeks.org/user/sri_akshat5",
    },
  ];

  return (
    <div className="bg-white shadow-md rounded-md p-6 ">
      <h2 className="text-2xl font-semibold mb-4">Featured</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {links.map((item) => (
          <div
            key={item.id}
            className="border rounded-md shadow hover:shadow-lg transition p-4"
          >
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              <img
                src={item.image}
                alt={item.subtitle}
                className="h-16 mx-auto mb-4"
              />
              <h3 className="text-lg font-semibold">{item.title}</h3>
              <p className="text-sm text-gray-500">{item.subtitle}</p>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturedLinks;
